import { useEffect, useState } from "react";
import { useSelector } from "react-redux";

function useQrCount() {
  const [initialQrCount, setInitialQrCount] = useState(0);
  const createdQrCount = useSelector((state) => state.getQrLinkSlice.createdQrCount);
  const QR_LIMIT_WARNING = 9900;
  const QR_LIMIT = 10000;

  useEffect(() => {
    const appUserElement =
      document.querySelector("#app-user") ||
      document.querySelector("#app-user-iframe");
    if (appUserElement) {
      setInitialQrCount(Number(appUserElement.dataset.qrCount) || 0);
    }
  }, []);

  const qrCount = initialQrCount + createdQrCount;

  return {
    qrCount,
    qrLimit: QR_LIMIT,
    qrLimitWarning: QR_LIMIT_WARNING,
    qrLimitReached: qrCount >= QR_LIMIT
  };
}

export default useQrCount;
